'use client';

import React from 'react';
import { Box, Button, Flex, Link, Text } from '@skin-seoul/design-system';
interface LoyaltySignUpBannerDesktopProps {
  titleLine2?: string;
}
export const LoyaltySignUpBannerDesktop = ({
  titleLine2 = 'SkinSociety'
}: LoyaltySignUpBannerDesktopProps) => {
  return <Box position="relative" width="100%" height="112px" borderRadius="8px" bgGradient="to-tl" gradientFrom="#311275" gradientTo="#754DCC" overflow="hidden" data-sentry-element="Box" data-sentry-component="LoyaltySignUpBannerDesktop" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" pl={4} pr={6} py={4} zIndex={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
        {/* Left Side - Title and Subtitle */}
        <Flex direction="column" gap={2} data-sentry-element="Flex" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
          <Flex direction="column" gap={0} data-sentry-element="Flex" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
              Join {titleLine2}
            </Text>
            <Text as="span" color="primary.100" textStyle="heading.h6" fontWeight="bold" data-sentry-element="Text" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
              & Start Earning
            </Text>
          </Flex>
          <Text color="primary.100" textStyle="label.small" data-sentry-element="Text" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
            Sign up to earn rewards
          </Text>
        </Flex>

        {/* Right Side - Sign Up Button */}
        <Button asChild size="md" variant="primary" bg="white" color="neutral.800" _hover={{
        bg: 'neutral.50'
      }} px={6} height="44px" data-sentry-element="Button" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
          <Link unstyled href="/my-account/" data-sentry-element="Link" data-sentry-source-file="LoyaltySignUpBanner.Desktop.tsx">
            Sign Up
          </Link>
        </Button>
      </Flex>
    </Box>;
};